import React, { useState, useEffect } from 'react';
import {
    Text, View, Image, StyleSheet, ScrollView, Pressable
} from 'react-native';
import * as CommonUtils from '../../utils/services/CommonUtils';
import AppStyles from "../../AppStyles";
import { store } from "../../store/store";
import AppTheme from '../../AppTheme';
import { CommonAddMemberHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import * as rxjsService from "../../utils/services/subject-behaviour/CommonRxjsService";
import { updateAddUpdateScreenData } from '../../utils/services/redux/commonRedux';
import OmsStyles from '../../OmsStyle';
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { CommonRightChevronIcon } from '../../utils/widgets/Common-Widget';

const MemberList = (props) => {
    const reduxState = store.getState();
    const [familyMembers, updatefamilyMembers] = useState(reduxState?.familydetails['familyMembers'] ?? []);
    const [userDetails, updateUserDetails] = useState(reduxState.userDetails)

    useEffect(() => {

        rxjsService.familyDetailsSubscription.getFamilyDetails().subscribe((familyData: any) => {
            if (familyData) {
                let familyMembers: any = [...familyData]
                updatefamilyMembers(familyMembers);
            }
        })

        rxjsService.userDetailsSubscription.getUserDetails().subscribe((userData: any) => {
            if (userData) {
                updateUserDetails(userData);
            }
        })
    }, [])

    function upsertMemberDetails(isUpdate, member: any = null) {
        if (userDetails['isProfileComplete']) {
            updateAddUpdateScreenData({
                isUpdate: isUpdate,
                user: member, screenName: ScreenRoute.list_member,
                isSelf: member?.relation == 'Self' || member?.relation == 'Self',
                props: props
            })
            setTimeout(() => { props.navigation.navigate(ScreenRoute.upsert_family_data) }, 100)
        } else {
            props.navigation.navigate(ScreenRoute.complete_profile)
        }
    };

    return (
        <View>

            <CommonAddMemberHeader navigation={props.navigation} title='Your Family'
                addMember={() => { upsertMemberDetails(false, null) }} />

            <ScrollView style={{
                marginTop: AppTheme.headerHeight,
                paddingTop: 16, paddingBottom: 24,
                height: AppTheme.appHeight,
                backgroundColor: AppTheme.color.background
            }}>
                {
                    userDetails['isProfileComplete'] && familyMembers.map((member, i) => (
                        <Pressable key={i} style={[
                            styles.members, AppStyles.mediumShadow,
                            AppStyles.flexRowSpaceBetween]}
                            onPress={() => upsertMemberDetails(true, member)}>

                            <View style={[AppStyles.flexRow]}>

                                <Image source={{
                                    uri: CommonUtils.getMemberProfileURL(member),
                                    width: 46, height: 46
                                }}
                                    style={{
                                        borderRadius: 50,
                                        borderWidth: 1,
                                        borderColor: AppTheme.color.lightGreyColor
                                    }} />

                                <View style={{ marginLeft: 16 }}>

                                    <Text numberOfLines={1} style={[OmsStyles.text14b, { width: AppTheme.appWidth - 135 }]}>{member['name']}</Text>

                                    <Text style={[OmsStyles.text12b, { color: AppTheme.color.grey.fillerInfo, marginTop: 10 }]}>
                                        ({member['relation']})</Text>

                                </View></View>

                            {CommonRightChevronIcon('black')}
                        </Pressable>
                    ))
                }
            </ScrollView>


        </View>
    )
}

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    members: {
        marginHorizontal: 16, marginBottom: 16, elevation: 18, paddingVertical: 16, paddingHorizontal: 16,
        borderRadius: 12, backgroundColor: 'white'
    },
    addMember: { fontSize: 16, color: AppTheme.color.primary, paddingLeft: 8 }
}))

export default MemberList;